import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import { toast } from 'sonner';
import { configureCore, webStorage } from '@vaulzo/core';
import { queryClient } from '@vaulzo/core/queryClient';
import { Toaster } from '@/components/ui/sonner';

// Wire the shared core to this host: API origin, where the token lives, how to toast.
configureCore({
  baseUrl: process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080',
  storage: webStorage,
  notify: { success: toast.success, error: toast.error, info: toast.info },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster position="top-right" />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

// Register service worker in production so the app can be installed (PWA)
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;
    navigator.serviceWorker.register(swUrl).catch(() => {});
  });
}